var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dashboard-content',{attrs:{"full-width":""}},[_c('v-row',[_c('v-col',{staticClass:"col-12 py-0"},[_c('h1',{staticClass:"mb-4"},[_vm._v(" Subscriptions ")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"item-key":"id","headers":_vm.headers,"items":_vm.subscribers,"loading":_vm.loading}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }